
// Response types are defined here =
// https://github.com/libp2p/go-libp2p-core/blob/6e566d10f4a5447317a66d64c7459954b969bdab/routing/query.go#L15-L24
export const SendingQuery = 0
export const PeerResponse = 1
export const FinalPeer = 2
export const QueryError = 3
export const Provider = 4
export const Value = 5
export const AddingPeer = 6
export const DialingPeer = 7
